import { QueryClient } from '@tanstack/react-query'

/**
 * The one cache.
 *
 * Lives here rather than in main.tsx because signing out has to clear it from
 * outside React — see `features/auth/api.ts`. A stale `me` surviving a logout
 * is how you end up showing the previous person's name to whoever sits down
 * next.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      /*
       * Explicit, though it is also the default.
       *
       * Every live surface in this app has a second recovery path — each
       * `subscribe()` refetches in its `onStart` — but that only fires when the
       * *socket* comes back. This one covers the browser coming back, which is
       * a different event and the one that happens when a laptop is opened.
       * Stating it means the two are a decision rather than one default and one
       * deliberate handler.
       */
      refetchOnReconnect: true,
    },
  },
})
